<template>
	<div>
		<titles titlename="角色管理" titlecontent="这里可以管理角色" :mbx="paths"></titles>
		<manges :pagesobj="pagesobj" :tabtitlelist="tabtitlelsit" :mangesname="mangesname" :tablist="tablist"></manges>
	</div>
</template>

<script>
	import titles from "@/components/title/title.vue"
	import manges from "@/components/mangeslist/manges.vue"
	import {
		GetjsPageRoleList
	} from "@/request/api/mange/mange.js"
import AppOptions from '@/config/AppOptions.vue';

	export default {
		data() {
			return {
				pagesobj: {
					pageIndex: 1,
					pageSize: 10,
					pro_name: "",
					maxpages: null,
					rl_parentGuid: "",
					rl_name:""
				},
				mangesname: {
					name: "角色",
					topcolor: "#6571FF",
					contentcolor: "#9C27B0",
					show: false
				},
				tabtitlelsit: [{
						label: "角色名称",
						prop: "rl_name",
					},
					{
						label: "备注",
						prop: "rl_remark",
					}
				],

				tablist: [],


				// 标题组件
				paths: [{
					path: "/qitamanage/usermange",
					name: "角色管理"
				}]
			}
		},
		mounted() {
			this.getjsuser(this.pagesobj)
		},
		created() {
			AppOptions.appEmpty = false;
		},
		methods: {
			getjsuser() {
				GetjsPageRoleList(this.pagesobj).then(res => {
					// console.log(res,"角色列表")
					this.tablist = res.data.data.list
					this.pagesobj.maxpages = res.data.data.totalCount
				})

			}
		},
		components: {
			titles,
			manges
		}

	}
</script>

<style lang="less">
	/deep/ .el-dialog__header {
		padding: 14px 19px 10px;
		background: #05A34A;
		color: #fff;
		font-size: 1.2rem;
	
		.el-dialog__headerbtn .el-dialog__close {
			color: #fff;
			font-size: 1.4rem;
	
		}
	
		.dialog-header-title {
			span {
				margin-left: 0.6rem;
			}
		}
	}
</style>
